export const tr = {
    'add-additions-item-callouts': 'Netleştirmeleri ekle',
    'add-banners-display-hrefs': 'Gösterilen bağlantıları ekle',
    'add-creatives': "Medya banner'larına kreatifler ekle",
    'add-image-to-banner': 'Görsel ekle',
    'add-more-pictures-to-adgroup': 'Görselleri ekle',
    'add-outdoor-creatives': 'Dış mekan reklamlarına kreatifler ekle',
    'add-placements': 'Reklam panoları ekle',
    'add-site-links': 'Hızlı bağlantılar ekle',
    'add-title-extension': 'İkinci başlık ekle',
    'add-turbo-web-site-to-banner': 'Turbo sayfa ekle',
    'all-platforms': 'Tüm reklam alanlarında',
    archived: 'Arşivde',
    'autobudget-priority': 'Öncelik',
    avgClickCost: 'Ortalama tıklama fiyatı',
    avgCpmCost: '1000 gösterim başına ortalama fiyat',
    avgGoalCost: 'CPA',
    'banner-body': 'Reklam metni',
    'banner-status-active': 'Aktif',
    'banner-status-archived': 'Arşivde',
    'banner-status-draft': 'Taslak',
    'banner-status-manually-suspended': 'Durduruldu',
    'banner-status-moderation': 'Moderasyonda',
    'banner-status-moderation-rejected': 'Moderasyonda reddedildi',
    'banner-status-temporarly-suspended': 'Geçeci olarak durduruldu',
    'banner-title': 'Başlık',
    'banner-title-extension': 'Başlık genişletme',
    'banner-type': 'Reklam türü',
    'banner-type-cpm_metro': "Yandex Metro banner'ı",
    'bid-modifiers': 'Teklif düzenlemeleri',
    'bounce-rate': 'Hemen çıkma',
    broadmatch: 'İlgili ek sözcük grupları',
    budgetLimit: 'Bütçe kısıtlaması',
    'campaign-type': 'Kampanya türü',
    'change-adgroup-for-moderation': 'Moderasyondan geç',
    'change-adgroup-with-low-stat': '"Gösterim sayısı az" olan grupları düzenle',
    'change-banner-for-moderation': 'Moderasyonu geç',
    clicks: 'Tıklamalar',
    context: 'Ağlarda',
    'context-price': 'Teklif (ağlarda)',
    'converison-rate': '% dönüşümler',
    cost: 'Harcama',
    cpa: 'CPA',
    cpc: 'CPC',
    cpm: 'Bin Gösterim Başına Maliyet',
    ctr: 'CTR',
    'daily-budget': 'Bütçe sınırını yükselt',
    'deal-id': 'Anlaşma numarası',
    'deal-type': 'Anlaşma türü',
    disabled: 'Kapalı',
    draft: 'Taslak',
    enabled: 'Açık',
    'finish-date': 'Bitiş tarihi',
    goals: 'Dönüşümler',
    'group-status-active': 'Aktif',
    'group-status-archived': 'Arşivde',
    'group-status-draft': 'Taslak',
    'group-status-moderation': 'Moderasyonda',
    'group-status-rejected': 'Moderasyonda reddedildi',
    'group-status-stopped': 'Durduruldu',
    'has-image': 'Görsel',
    'has-sitelinks': 'Hızlı bağlantılar',
    'has-turbolanding': 'Turbo sayfalar',
    id: 'ID',
    keyword: 'Anahtar sözcük grupları',
    libraryMinusPhrasePacks: 'Negatif anahtar sözcük grubu dizileri',
    metrics: 'İstatistikler',
    metrika: 'Yandex.Metrica sayacı',
    'min-price': 'Bin gösterim başına minimum maliyet',
    'minus-phrase-packs': 'Negatif anahtar sözcük grubu dizileri',
    'moderation-denied': 'Moderasyon sonucunda reddedildi',
    'moderation-pending': 'Moderasyonda',
    'money-finished': 'Bakiye tükendi',
    name: 'İsim',
    'name-minus-phrase-packs': 'Negatif anahtar sözcük grubu dizisinin adı',
    number: 'Numara',
    numberOfLinkedCampaigns: 'Bağlı kampanyaların sayısı',
    'phrase-status-active': 'Aktif',
    'phrase-status-archived': 'Arşivde',
    'phrase-status-draft': 'Taslak',
    'phrase-status-moderation-rejected': 'Sözcük grubu moderasyonda reddedildi',
    'phrase-status-suspended': 'Durduruldu',
    platform: 'Gösterim yerleri',
    price: 'Maksimum tıklama fiyatı',
    'price-context': 'Maksimum tıklama fiyatı (ağlarda)',
    'price-context-cpm': '1000 gösterim başına teklif',
    profitability: 'ROI',
    recommendations: 'Öneriler',
    'remove-page-from-blacklist': 'Kaliteli reklam alanlarını etkinleştir',
    revenue: 'Gelir',
    search: "Arama'da",
    'send-licenses': 'Belgeleri gönder',
    'send-licenses-banks': '"Bankacılık hizmetleri" konusuna göre belgeleri gönder',
    'send-licenses-med-services': '"Tıbbi hizmetler" konusuna göre garanti mektubu gönder',
    'send-licenses-pharmacy': '"Eczaneler ve ilaçlar" konusuna göre garanti mektubu gönder',
    settings: 'Ayarlar',
    shows: 'Gösterimler',
    'site-monitoring': 'Site izlemesi',
    spent: 'Masraflar',
    'start-date': 'Başlangıç tarihi',
    started: 'Başlatıldı',
    'statistics-by-all-goals': 'Tüm hedeflere göre',
    status: 'Durum',
    stopped: 'Durdurulan',
    strategy: 'Strateji',
    'switch-on-autotargeting': 'Otomatik hedeflemeyi etkinleştir',
    'target-funnel': 'Hedef kitle',
    'temporarily-paused': 'Geçici olarak durduruldu'
};
